import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {getCurrentMicroTime} from "reducers/timeMeasuring/actions";
import Slider, {Range} from 'rc-slider';
import Tooltip from 'rc-tooltip';
import 'rc-slider/assets/index.css';
import ScalePoints from "container/Question/ScalePoints";
import classnames from "classnames";
import {Input} from "reactstrap";
import ImageOpenAnswer from "../../Components/imageOpenAnswer";
import AnswerContainer from "../../Components/answerContainer";
import _ from "lodash";
import CafeteryWrapInput from "../../Components/cafeteryWrapInput";
import {SliderInputs} from "../../Components/slider/sliderInputs";
import SliderSummary from "../../Components/slider/sliderSummary";

class PresentationTypeSlider extends Component {

  constructor(props){
    super(props);
    this.sliderInputs = React.createRef();
    this.state = {
      touched: false
    };

    this.onAnswerValueChange = this.onAnswerValueChange.bind(this);
    this.getSlider = this.getSlider.bind(this);
    this.getMinValue = this.getMinValue.bind(this);
    this.getMaxValue = this.getMaxValue.bind(this);
    this.getDefaultValue = this.getDefaultValue.bind(this);
    this.getFormattedValue = this.getFormattedValue.bind(this);
  }

  getFormattedValue(value){
    const {question, forceMinValue} = this.props;
    if (forceMinValue && forceMinValue > value) {
      return forceMinValue
    }

    return value;
  }

  onAnswerValueChange(value, property){
    let {detail, answer, question} = this.props;
    const microTime = getCurrentMicroTime(this.props.startTime);

    this.setState({
      touched: true
    })

    detail = {
      ...detail,
      microTime,
      answer: answer.id,
      [property]: value,
    };

    if (question.showSliderInputs && this.sliderInputs && this.sliderInputs.current && this.sliderInputs.current.setInputValueForce) {
      this.sliderInputs.current.setInputValueForce(detail);
    }

    this.props.onDetailUpdated(detail);
  }

  getMinValue(){
    const {answer, question} = this.props;
    const minValue = answer.minValue || question.valueMin;

    return Number(minValue)
  }

  getMaxValue(){
    const {answer, question, details, detail} = this.props;
    const maxValue = answer.maxValue || question.valueMax;

    return Number(maxValue);
  }

  getDefaultValue(){
    if(this.props.question.defaultValueMiddle){
      return ((this.getMaxValue() - this.getMinValue()) / 2) + this.getMinValue();
    }

    return this.props.question.defaultValue;
  }

  getSlider() {
    const {detail, question, isError, forceMinValue, validate, answer, forceMaxValue} = this.props;
    const Handle = Slider.Handle;


	  let min = this.getMinValue();
	  let max = this.getMaxValue();
	  if (min && question.decimals) {
		  min = min * Math.pow(10, question.decimals)
	  }
	  if (max && question.decimals) {
		  max = max * Math.pow(10, question.decimals)
	  }
	  let defaultValue = this.getDefaultValue()
	  if (defaultValue && question.decimals) {
		  defaultValue = defaultValue * Math.pow(10, question.decimals)
	  }
	  let value1 = detail.value1;
      if (forceMinValue && forceMinValue > value1) {
        value1 = forceMinValue;
      }
	  let value2 = detail.value2;

    const handle = (props) => {
      const { value, dragging, index, ...restProps } = props;

      let valueDisplay = this.getFormattedValue(value);
      if (question.decimals) {
        valueDisplay = valueDisplay / Math.pow(10, question.decimals)
      }

      if(question.valueText){
        valueDisplay += ' ' + question.valueText;
      }

      return (
        <Tooltip
          prefixCls="rc-slider-tooltip"
          overlay={valueDisplay}
          visible={dragging}
          placement="top"
          key={index}
        >
          <Handle value={value} {...restProps} />
        </Tooltip>
      );
    };

    if (this.props.question.range) {
      return <Range
        className={isError ? "error" : ""}
        handle={question.hideSelectingValue ? undefined : handle}
        min={min}
        max={max}
        step={question.step}
        onChange={(values) => {
          if (values[0] !== detail.value1) {
            this.onAnswerValueChange(values[0], 'value1');
          } else {
            this.onAnswerValueChange(values[1], 'value2');
          }
        }}
        value={(!_.isNull(detail.value1) || !_.isNull(detail.value2)) ? [detail.value1, detail.value2] : [min,max]}
        count={2}
      />;
    }

    return <Slider
      className={(!_.isNull(validate) && validate.errors.length > 0) ? "error" : ""}
      handle={question.hideSelectingValue ? undefined : handle}
      vertical={!!question.sliderVertical}
      min={min}
      max={max}
      step={question.step}
      onChange={(value) => {
        if (forceMaxValue && value > forceMaxValue) {
          value = forceMaxValue;
        } else if (forceMinValue && forceMinValue > value) {
          value = forceMinValue;
        } else {
          value = this.getFormattedValue(value)
        }

        this.onAnswerValueChange(value, 'value1')
      }}
		value={!_.isNull(value1) ? value1 : defaultValue}
    />;
  }

  render() {
    const {answer, question, detail, onOpenChange, onBlur, isError, forceMinValue} = this.props;
    const {touched} = this.state;

    return <React.Fragment>
        <AnswerContainer
          classes={"text-center pointer-none font-weight-bold p-0"}
          answer={answer}
          checked={false}
          component={
            <ImageOpenAnswer
                answer={answer}
                detail={null}
                checkboxType={''}
                answersImage={question.answersImage}
                showInput={false}
                showContent={true}
                onOpenChange={onOpenChange}
                onBlur={onBlur}
                answerOpenAlwaysShow={false}
            />
          }
      />
      <SliderInputs
        ref={this.sliderInputs}
        detail={detail}
        question={question}
        touched={touched}
        isError={isError}
        onValueChangeFirst={(value) => {
          this.onAnswerValueChange(value, 'value1')
        }}
        onValueChangeSecond={(value) => {
          this.onAnswerValueChange(value, 'value2')
        }}
      />

      {!question.scalePoints && <div className="d-flex">
        <span className="w-50">{question.valueMin} {question.valueText}</span>
        <span className="w-50 text-right">{question.valueMax} {question.valueText}</span>
      </div>}
      {!question.sliderVertical && <div>
        <div className={"mb-3"}>
          <ScalePoints scalePoints={question.scalePoints} />
        </div>
      </div>}
      <div className={classnames({
        "pl-4 pr-4 mb-5 mt-5 pt-2": true,
        "mt-5": question.sliderVertical,
        "d-flex justify-content-center": question.sliderVertical
      })}>
        {this.getSlider()}
        <SliderSummary question={question} detail={detail} min={this.getMinValue()} max={this.getMaxValue()} />
      </div>
      {answer.isOpen && <div className={"mt-5 pt-3"}><CafeteryWrapInput
        error={isError}
        onChange={onOpenChange}
        value={detail.content || ''}
        dataId={answer.id + "-content"}
        /></div>
      }
    </React.Fragment>
  }
}

PresentationTypeSlider.propTypes = {
  defaultValue: PropTypes.number,
  answer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    isOpen: PropTypes.bool.isRequired,
  }).isRequired,
  detail: PropTypes.shape({
    answer: PropTypes.number.isRequired,
    value1: PropTypes.number,
    value2: PropTypes.number,
  }),
  question: PropTypes.shape({
    valueMin: PropTypes.number.isRequired,
    valueMax: PropTypes.number.isRequired,
    decimals: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired,
    valueText: PropTypes.string,
    hideSelectedValue: PropTypes.bool.isRequired,
    hideSelectingValue: PropTypes.bool.isRequired,
    scalePoints: PropTypes.arrayOf(PropTypes.shape({
      content: PropTypes.string.isRequired
    }).isRequired).isRequired,
    range: PropTypes.bool.isRequired,
    sliderVertical: PropTypes.bool,
  }).isRequired,
  onDetailUpdated: PropTypes.func.isRequired,
};

export default connect((state) => {
  return {
    surveyNav: state.surveyNav,
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true})(PresentationTypeSlider);